import client from '../httpClient';

const sendmailUpdateApi = (params) => {
  return client.put('/send-mails/', params, { isShowMessage: true });
};

export default sendmailUpdateApi;
